import { sendEventLogin } from 'helpers/analytics';
import { setApplicationStatus } from 'store/actions/loanApply';

export const handleSuccessValidateOtp = (dispatch, action) => {
  dispatch(setApplicationStatus(''));
  action?.success?.();

  sendEventLogin({
    action: 'User Successfully Input the OTP Login',
    label: 'OTP'
  });
};
